import { FC } from 'react';

import { Button, CtaLink } from '@purpur/library';
import { IconArrowRight } from '@purpur/library/icon/arrow-right';

import { ORDER_CART_TEST_ID } from '../constants';
import { CartSecondaryActionData, isTypeLinkHandler } from '../model';

export const CartSecondaryAction: FC<{ data: CartSecondaryActionData }> = ({ data }) => {
    if (isTypeLinkHandler(data)) {
        return (
            <CtaLink
                variant={data.variant || 'secondary'}
                onClick={data.onClick}
                href={data.url}
                showIcon={data.hasArrow}
                fullWidth={true}
                data-test={ORDER_CART_TEST_ID.SECONDARY_ACTION}
            >
                {data.text}
            </CtaLink>
        );
    }

    return (
        <Button
            variant={data.variant || 'secondary'}
            onClick={data.onClick}
            fullWidth={true}
            data-test={ORDER_CART_TEST_ID.SECONDARY_ACTION}
            disabled={data.isDisabled}
            loading={data.isLoading}
        >
            {data.text}
            {data.hasArrow && <IconArrowRight size="xs" />}
        </Button>
    );
};
